import React, { useEffect } from 'react'
import { copyDataByCondition } from 'designer/component/action/Condition'
import { onUpdateCondition } from 'designer/component/action/condition/Action'
import { isEmpty } from 'designer/component/action/condition/State'
import { getCheckValue } from 'designer/component/action/Data'
import CustomColorPicker from 'designer/component/element/ColorPicker'
import { getStorage } from 'designer/component/action/Storage'
import PropWrapper from './PropWrapper'
import {
  updateFieldValue,
  updateMapResponse,
  updateOnChange,
  updateWidgetData,
} from './DataControl'

const Children = ({ dataProps }) => {
  const {
    props,
    designContext,
    fieldProps,
    fieldName,
    fieldKey,
    errors,
    setIsOnChange,
  } = dataProps
  const { jsonForm, setFormData, isResetData, elementAction } = designContext
  const { uischema, config } = props
  const { format, label } = uischema
  const formData = jsonForm.formData
  const {
    uiKey,
    uiName,
    value,
    data,
    defaultValue,
    renderWidget,
    mapResponse,
  } = fieldProps

  const updateData = (value, isOnChange = false) => {
    updateFieldValue({ ...dataProps, value, isOnChange })
  }

  const copyData = (value) => {
    let newFormData = copyDataByCondition(value, elementAction, uiKey, formData)
    setFormData(newFormData)
  }

  useEffect(() => {
    updateOnChange({ ...dataProps, value })
  }, [value])

  useEffect(() => {
    if (isEmpty(value) || isResetData) {
      let storage = getStorage(jsonForm, uiName)
      let value
      if (isEmpty(storage)) {
        value = defaultValue
      } else {
        value = storage
      }
      value = getCheckValue(value, format)
      updateData(value, false)
      onUpdateCondition(props, designContext, uiKey, data)
    }
  }, [defaultValue, isResetData])

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  return (
    <>
      <CustomColorPicker
        fieldName={fieldName}
        fieldKey={fieldKey}
        label={label}
        uischema={uischema}
        data={data}
        color={value}
        uiKey={uiKey}
        updateColor={updateData}
        copyData={copyData}
        errors={errors}
        config={config}
        setIsOnChange={setIsOnChange}
      />
    </>
  )
}

const ColorPickerControl = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default ColorPickerControl
